import { render } from "./TermsAgreement.vue?vue&type=template&id=b33365f6"
import script from "./TermsAgreement.vue?vue&type=script&lang=js"
export * from "./TermsAgreement.vue?vue&type=script&lang=js"

import "./TermsAgreement.vue?vue&type=style&index=0&id=b33365f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__